<!-- START Sidebar (left)-->
<div class="aside-inner">
  <nav
    class="sidebar"
    sidebar-anyclick-close=""
    [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')"
  >
    <!-- START sidebar nav-->
    <ul class="sidebar-nav sidebar_nav">
      <!-- START user info-->
      <li class="has-user-block">
        <app-userblock></app-userblock>
      </li>
      <!-- END user info-->

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/home']" title="Summary">
          <!-- <img src="assets/img/fastswifficon/analytics-up-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/analytics-up.svg" class="" />

          <p class="text-dashboard" style="vertical-align: text-bottom">
            Summary
          </p>
        </a>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/transactions/smartlink-manage']" title="Smart Link">
          <img src="assets/img/smarlink.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Smart Link
            <!-- <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i> -->
          </p>
        </a>

        <ul class="sub-menu">
          <!-- <li
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions/new']"
          >
            Create
          </li> -->
          <!-- <li
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions/smartlink-manage']"
          >
            Manage
          </li> -->
        </ul>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/invoice/manage']" title="E-Invoice">
          <img src="assets/img/einvoice.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            E-Invoice
            <!-- <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i> -->
          </p>
        </a>
        <ul class="sub-menu">
          <!-- <li [routerLinkActive]="['active']" [routerLink]="['/invoice/new']">
            Create
          </li> -->
          <!-- <li
            [routerLinkActive]="['active']"
            [routerLink]="['/invoice/manage']"
          >
            Manage
          </li> -->
        </ul>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/ecomsolutions/Paynow/new']" title="E-Button">
          <img src="assets/img/ebutton.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            E-Button
            <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i>
          </p>
        </a>
        <ul class="sub-menu">
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/ecomsolutions/Paynow/new']"
          >
            Create
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/ecomsolutions/Paynow/manage']"
          >
            Manage
          </li>
        </ul>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/pay-profile/analytics']" title="Digi Page">
          <!-- <img src="assets/img/fastswifficon/digipage-2.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/digipage-1.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Digi Page
          </p>
        </a>
      </li>

      <li [routerLinkActive]="['active']" *ngIf="PaygsetUphideshow">
        <a [routerLink]="['/transactions/orderslist']" title="Manage">
          <img src="assets/img/fastswifficon/manage.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Manage
            <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i>
          </p>
        </a>
        <ul class="sub-menu">
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions/orderslist']"
          >
            Payment Orders
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions/manage']"
          >
            Transaction
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settlementvendors/manage']"
          >
            Settlement Vendors
          </li>
          <!-- <li [routerLinkActive]="['active']"  [routerLink]="['/invoice/manage']">E-Invoice</li>
          <li [routerLinkActive]="['active']"  [routerLink]="['/ecomsolutions/Paynow/manage']">E-Button</li> -->
        </ul>
      </li>

      <!-- <li [routerLinkActive]="['active']" *ngIf="PaygsetUphideshow">
        <a  *ngIf="newoption" [routerLink]="['/transactions/new']">
          <em class="fas  new-icon "></em>

          <p style="vertical-align: text-bottom;">New</p>
        </a>
      </li> -->
      <li [routerLinkActive]="['active']" *ngIf="payoutgideshow">
        <a [routerLink]="['/PayOut/AccountBalance']" title="ChargeBack">
          <!-- <em class="fas charge-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/chargeback-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/chargeback.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            PayOut
          </p>
        </a>
      </li>


      <!-- <li [routerLinkActive]="['active']" *ngIf="payoutgideshow">
        <a [routerLink]="['/PayOut/AccountBalance']">

          <img src="assets/img/dashboard_icons/payout1.svg" class="light_icon" />
          <img src="assets/img/dashboard_icons/payout.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom;">PayOut</p>
        </a>

      </li> -->
      <!-- <li [routerLinkActive]="['active']" *ngIf="prepaidcard">
        <a [routerLink]="['/prepaidcards/manage']">
           <em class="fas fa-credit-card"></em>
          <img src="assets/img/dashboard_icons/gift_card.svg" class="light_icon" />
          <img src="assets/img/dashboard_icons/gift_card1.svg" class="" />

          <p class="text-dashboard" style="vertical-align: text-bottom;">Merchant Gift <br> Card</p>
        </a>
      </li> -->
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/settings/ChargeBack']" title="ChargeBack">
          <!-- <em class="fas charge-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/chargeback-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/chargeback.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            ChargeBack
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']">
        <a
          [routerLink]="['/transactions/Refundtransactions']"
          title="Refund Transactions"
        >
          <!-- <em class="fas charge-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/refund.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/refund-1.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Refund Transactions
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']" *ngIf="ReserveFund">
        <a [routerLink]="['/settings/reservefunddetails']" title="Reserve Fund">
          <!-- <em class="fas report-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/Reserve Fund-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/Reserve Fund.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Reserve Fund
          </p>
        </a>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/reports/Fundreport']" title="Transaction Summary">
          <img
            src="assets/img/fastswifficon/Transaction Summary.svg"
            class=""
          />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Transaction Summary
          </p>
          <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i>
        </a>
        <ul class="sub-menu">
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/Fundreport']"
          >
            Fund Settlement
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/paymentledger']"
          >
            Payment Ledger
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/transactions/batch']"
          >
            Batch Settlement
          </li>
        </ul>
      </li>

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/reports/transactions/summary']" title="Reports">
          <!-- <em class="fas report-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/Reports-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/Reports.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Reports
          </p>
          <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i>
        </a>
        <ul class="sub-menu">
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/transactions/summary']"
          >
            Transaction Summary
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/feereport']"
          >
            Fee Report
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/misReport']"
          >
            MIS
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/QuickCodeTransactionSummary']"
          >
            QuickCode Transaction
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/postbackdata']"
          >
            Webhook Data
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/reconciliation']"
          >
            Reconciliation Report
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/reports/payinorderfailurelog']"
          >
            Order Failure
          </li>
          <!-- <li [routerLinkActive]="['active']"  [routerLink]="['/featuresEnabled/featuresEnabled']">Services and Fees </li>   -->
        </ul>
      </li>
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/settings/AuthenticationKey']" title="Settings">
          <!-- <em class="fas setting-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/settings-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/settings.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Settings
          </p>
          <i class="fa fa-caret-down submenuIcons" aria-hidden="true"></i>
        </a>
        <ul class="sub-menu">
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/AuthenticationKey']"
          >
            Authentication Keys
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/merchantsettings']"
          >
            Merchant Settings
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/manage']"
          >
            User Management
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/downloaddocuments']"
          >
            Download Documents
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/documentUpload']"
          >
            Upload Documents
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/documentdetails']"
          >
            Document Details
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/BankDetails']"
          >
            Bank Details
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/PostBackurl']"
          >
            Webhook Url
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/NotificationList']"
          >
            Notifications List
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/featuresEnabled/featuresEnabled']"
          >
            Services and Fees
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/agreements/list']"
          >
            Agreements
          </li>
          <li
            [routerLinkActive]="['active']"
            [routerLink]="['/settings/GetMerchantIpConfigurations']"
          >
            Merchant IpAddress Configurations
          </li>
          <!-- <li [routerLinkActive]="['active']"  [routerLink]="['/settings/ChargeBack']">ChargeBack</li>   -->
        </ul>
      </li>
      <li [routerLinkActive]="['active']" *ngIf="PosSetuUphideshow">
        <a [routerLink]="['/pos/pos']" title="E-Store">
          <!-- <em class="fas pos-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/estore-2.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/estore-1.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            E-Store
          </p>
        </a>
      </li>
      <li [routerLinkActive]="['active']" *ngIf="PosSetuUphideshow">
        <a [routerLink]="['/accounting/dashboard']" title="Accounting">
          <!-- <em class="fas pos-icon"></em> -->
          <!-- <img src="assets/img/fastswifficon/estore-2.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/estore-1.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Accounting
          </p>
        </a>
      </li>
      <!-- <li [routerLinkActive]="['active']">
        <a [routerLink]="['/booking-dashboard/BookingDashboard']">

          <img src="assets/img/fastswifficon/ebookings-2.svg" class="light_icon" />
          <img src="assets/img/fastswifficon/ebookings-1.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom;">E-Bookings</p>
        </a>
      </li>  -->
      <li [routerLinkActive]="['active']" *ngIf="hidebutton">
        <a [routerLink]="['/settings/MobileApp']" title="Fastswiff App">
          <!-- <img src="assets/img/fastswifficon/App-1.svg" class="light_icon" /> -->
          <img src="assets/img/fastswifficon/App.svg" class="" />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Fastswiff App
          </p>
        </a>
      </li>
      <li
        [routerLinkActive]="['active']"
        *ngIf="hidebutton"
        (click)="navigateToLogin()"
      >
        <a [routerLink]="['']" title="Fastswiff App">
          <!-- <img src="assets/img/fastswifficon/App-1.svg" class="light_icon" /> -->
          <img
            src="assets/img/fastswifficon/logout_white.svg"
            class=""
            style="width: 10%; height: 10%"
          />
          <p class="text-dashboard" style="vertical-align: text-bottom">
            Logout
          </p>
        </a>
      </li>

      <!-- <li [routerLinkActive]="['active']">




                <a  [routerLink]="['/PayOut/PayoutLedgers']">
                  <em class="fas  report-icon"></em>

                  <span style="vertical-align: text-bottom;">PayOut Reports</span>
                </a>



              </li>
         -->
    </ul>
    <!-- END sidebar nav-->
  </nav>
</div>
<!-- END Sidebar (left)-->
